import { Component, Input, OnInit } from '@angular/core';
import { Ranking } from '../ranking';

@Component({
  selector: 'mc-ranking-selector',
  templateUrl: './ranking-selector.component.html',
  styleUrls: ['./ranking-selector.component.scss']
})
export class RankingSelectorComponent implements OnInit {

  @Input() rankings: Ranking[] = [];
  @Input() relativeRouterPath: (ranking: Ranking) => (string | number)[];
  @Input() currentGroupId: number | string | null;

  constructor(
  ) { }

  ngOnInit(): void {
  }

}
